import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getPrivacyPolicyThunk } from "live-slices/privacyPolicay/thunk";
import { getTermAndCanditionThunk } from 'live-slices/termAndCanditions/thunk';
import { updateUserState } from "live-slices/user/reducer";
import { createSelector } from 'reselect';
import { getAuthMe } from 'slices/thunks';
import axios from 'axios';

interface TermsPrivacyPopupProps {
  show: boolean;
  onCloseClick: () => void;
  type: 'terms' | 'privacy';
  onAccepted: () => void;
}

const selectUser = createSelector(
  (state: any) => state.User,
  (user) => user?.user
);



const TermsPrivacyPopup: React.FC<TermsPrivacyPopupProps> = ({ show, onCloseClick, type, onAccepted }) => {
  const dispatch = useDispatch<any>();
  const { policyData } = useSelector((state: any) => state.PolicySlice); // same for both thunks
  const [content, setContent] = useState('');
  const [activeTab, setActiveTab] = useState<'terms' | 'privacy'>(type);
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (e: any) => {
    setIsChecked(e.target.checked);
  };

  useEffect(() => {
    if (!show) return;

    setActiveTab(type);
    setIsChecked(false);

    if (type === "privacy") {
      dispatch(
        getPrivacyPolicyThunk({
          type: "privacyPolicy",
          isBuyPassPolicy: true,
        })
      );
    } else {
      dispatch(
        getTermAndCanditionThunk({
          type: "termsAndConditions",
          isBuyPassPolicy: true,
        })
      );
    }
  }, [dispatch, type, show]);



  const user = useSelector(selectUser);

  const handleAccept = async () => {
    try {
      await dispatch(
        updateUserState({
          storeStatus: {
            ...user.storeStatus,
            isPrivacyPolicyRead: true,
          },
        })
      );

      const response: any = await axios.put(`api/v1/business/policy?isPrivacyPolicyRead=true`);
      if (response && response.isSuccess === true) {
        setTimeout(async () => {
          const authRes = await dispatch(getAuthMe());
          const updatedUser = authRes?.payload;
          if (updatedUser?.storeStatus?.isPrivacyPolicyRead === true) {
            onAccepted();
            onCloseClick();
          } else {
            console.warn("User still not updated");
          }
        }, 500);
      }
      else {
        console.warn("Policy update failed or invalid response:", response);
      }
    } catch (err) {
      console.error("Error while accepting policy:", err);
    }
  };

  useEffect(() => {
    if (content) {
      setTimeout(() => {
        const container = document.querySelector(".scrolContentDv");
        if (container) {
          const links = container.querySelectorAll("a");
          links.forEach((link) => {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "noopener noreferrer");
          });
        }
      }, 0);
    }
  }, [content]);


  useEffect(() => {
    if (policyData) {
      const value = policyData?.data?.value || policyData?.value || '';
      setContent(value);
    }
  }, [policyData]);

  return (
    <Modal isOpen={show} toggle={onCloseClick} size="lg" className='termAndConditions'>

      <div className=' d-flex justify-content-between align-items-center w-100 haderDvTerm'>
        <h1></h1>
        < i className='bx  bx-x fw-bolder  ' onClick={onCloseClick} style={{ cursor: 'pointer' }} data-testing-id="CloseIcon"></i>
      </div>
      {/* <div className="tabBarDv">
          <div
            className={`item ${activeTab === 'terms' ? 'active' : ''}`}
            onClick={() => setActiveTab('terms')}
          >
            Terms and Conditions
          </div>
          <div
            className={`item ${activeTab === 'privacy' ? 'active' : ''}`}
            onClick={() => setActiveTab('privacy')}
          >
            Privacy Policy
          </div>
        </div> */}
      <p style={{ display: "flex", justifyContent: "center", fontSize: "25px" }}>
        {activeTab === 'terms' ? 'Terms & Conditions' : 'Privacy Policy'}
      </p>
      <div className='scrolContentDv'>
        <ModalBody>
          {content ? (
            <div
              className="text-muted"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          ) : (
            <p>Loading...</p>
          )}
        </ModalBody>

      </div>
      <ModalFooter>
        <div className='mainFoter d-flex justify-content-between align-items-center w-100'>
          {user?.storeStatus && (
            <div className=' d-flex justify-content-start align-items-center gap-2'>
              <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} data-testing-id="Checkbox" />
              <p>I have read agree to the Term & Conditions and Privacy Policy</p>
            </div>
          )}
          <div>
            {user?.storeStatus && (
              <button className='btn closeBtn me-2' onClick={onCloseClick} data-testing-id="cancel"> Cancel</button>
            )}
            {user?.storeStatus && (
              <button
                data-testing-id="Accept&Continue"
                className='btn btn-secondary'
                disabled={!isChecked}
                onClick={handleAccept}
              >
                Accept & Continue
              </button>
            )}

          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default TermsPrivacyPopup;
